import { Box, Button, Text, useToast } from "@chakra-ui/react";
import React, { useEffect } from "react";
import { BsLine } from "react-icons/bs";
import { waitTime } from "../../../utils/waitTime";
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";
import { lineLogin, lineOnlyLogin } from "../../../api/postApi";
import { useDispatch } from "react-redux";
import Cookies from "js-cookie";
import liff from "@line/liff";
import { useTranslation } from "react-i18next";
import { COMMON_WEB_PATH } from "../../../constant";
import useWebsiteInfo from "../../../hook/useWebsiteInfo";

const LineLogin = ({ setButtonLoading, buttonLoading, apiTrigger = false }) => {
  const { t } = useTranslation();
  const i18n = (key, props) => t(`header.${key}`, { ...props });
  const i18n_common = (key) => t(`common.${key}`);
  const [searchParams, setSearchParams] = useSearchParams();

  const line_code = searchParams.get("code");
  const state_code = searchParams.get("state");
  const trans_code = searchParams.get("trans_code"); //callback url的trans_code參數名稱為state
  const line_login = searchParams.get("line_login");
  const line_only_login = searchParams.get("line_only_login"); // 判斷是否為僅Line登入
  const invite_code = searchParams.get("invite");
  const line_id = searchParams.get("line_id");
  const line_name = searchParams.get("line_name");

  const dispatch = useDispatch();
  const { images } = useWebsiteInfo();
  const navigate = useNavigate();
  const toast = useToast();

  // useEffect(() => {
  //   const isLineLogin = searchParams.get("line_login") === "true";
  //   const lineId = searchParams.get("line_id");

  //   // 如果網址有 line_login=true 和 line_id，代表是從LINE登入回來的 走goLine
  //   if (isLineLogin && lineId) {
  //     setButtonLoading(true);
  //     lineLogin({
  //       line_id: line_id,
  //       trans_code: state_code,
  //     })
  //       .then((res) => {
  //         if (Cookies.get("token")) {
  //           // 清除舊的token並存入新的
  //           Cookies.remove("token");
  //         }
  //         Cookies.set("token", res.token, { expires: 3 }); // token 3天後過期
  //         dispatch({ type: "INITIALIZE_API", navigate: navigate }); // 初始化資料並導向首頁
  //         navigate("/");
  //       })
  //       .finally(() => {
  //         setButtonLoading(false);
  //       });
  //   }
  // }, [searchParams]);

  // 一進入頁面就初始化 LINE LIFF SDK
  // useEffect(() => {
  //   const initLiff = async () => {
  //     try {
  //       await liff.init({ liffId: process.env.REACT_APP_LINE_SIGNIN_LIFF_ID });
  //       if (liff.isLoggedIn()) {
  //         handleLineLogin(); // 如果已經登入 直接登入
  //       }
  //     } catch (error) {
  //       console.error("LINE初始化失敗:", error);
  //       // toast({
  //       //   title: "LINE初始化失敗",
  //       //   description: error.message,
  //       //   status: "error",
  //       //   duration: 2000,
  //       //   isClosable: true,
  //       // });
  //     }
  //   };
  //   initLiff();
  // }, []);

  // 處理 LINE 登入按鈕點擊
  const handleLineLogin = () => {
    const currentDomain = window.location.hostname;
    if (currentDomain.includes("oneone")) {
      window.location.href =
        "https://liff.line.me/2007745946-KXqM1wjD?into_site=theone";
    } else {
      window.location.href = "https://liff.line.me/2007099270-0n7YlEod";
    }
  };
  // const handleLineLogin = async () => {
  //   try {
  //     setButtonLoading(true);
  //     // 檢查是否已登入 LINE
  //     if (!liff.isLoggedIn()) {
  //       // 還沒登入就導向 LINE 登入頁
  //       liff.login();
  //     } else {
  //       // 已經登入就直接拿用戶資料
  //       const profile = await liff.getProfile();
  //       const lineId = profile.userId;

  //       // 拿到 LINE ID 後呼叫登入 API
  //       const res = await lineLogin({ line_id: lineId });
  //       // 移除舊的token 設置新的 token
  //       if (Cookies.get("token")) {
  //         Cookies.remove("token");
  //       }
  //       Cookies.set("token", res.token, { expires: 3 }); // token 3天後過期
  //       dispatch({ type: "INITIALIZE_API", navigate }); // 初始化資料並導向首頁
  //       navigate("/");
  //     }
  //   } catch (error) {
  //     console.error("LINE登入發生問題:", error);
  //     toast({
  //       title: "LINE登入失敗",
  //       description: error.message,
  //       status: "error",
  //       duration: 2000,
  //       isClosable: true,
  //     });
  //   } finally {
  //     setButtonLoading(false);
  //   }
  // };

  useEffect(() => {
    // 判斷是否為僅Line登入模式 如果網址有 line_only_login=true 就走lineOnlyLogin API
    if (line_only_login === "true") {
      setButtonLoading(true);
      lineOnlyLogin({
        trans_code: trans_code,
        line_id: line_id,
        line_name: line_name,
      })
        .then((res) => {
          console.log("LINE only login callback API response", res);
          if (Cookies.get("token")) {
            Cookies.remove("token");
          }
          Cookies.set("token", res.token, { expires: 3 });
          dispatch({ type: "INITIALIZE_API", navigate: navigate });
          navigate("/");
        })
        .catch((error) => {
          console.error("LINE只用在登入的回調失敗:", error);
        })
        .finally(() => {
          setButtonLoading(false);
        });
    }
    // 原本的Line登入邏輯 如果網址有 line_login=true 就走lineLogin API
    else if (line_login === "true") {
      setButtonLoading(true);
      lineLogin({
        // code: line_code,
        trans_code: trans_code,
        line_id: line_id,
        invite: invite_code,
        line_name: line_name,
      })
        .then((res) => {
          console.log("LINE callback API response", res);
          if (Cookies.get("token")) {
            Cookies.remove("token");
          }
          Cookies.set("token", res.token, { expires: 3 });
          dispatch({ type: "INITIALIZE_API", navigate: navigate });
          navigate("/");
        })
        .catch((error) => {
          console.error("LINE登入回調失敗:", error);
          // toast({
          //   title: "LINE登入回調失敗",
          //   description: `
          //   ${window.location.pathname}
          //   \n\n
          //   ${JSON.stringify(error, null, 2)}`,
          //   status: "error",
          //   duration: 2000,
          //   isClosable: true,
          // });
        })
        .finally(() => {
          setButtonLoading(false);
        });
    }
  }, [
    invite_code,
    line_login,
    line_only_login,
    trans_code,
    line_id,
    line_name,
    line_code,
  ]);

  return (
    <Button
      onClick={handleLineLogin}
      isLoading={buttonLoading}
      w="260px"
      h="55px"
      display={`flex`}
      alignItems={`center`}
      justifyContent={"center"}
      fontWeight={`medium`}
      // bg={`#49C755`}
      bgImage={`url('${images.lineBTN}')`}
      bgPosition="center"
      bgRepeat="no-repeat"
      bgSize="100% 100%"
      // py="20px"
      // pr="30px"
      type="button"
      id="customBtn"
      color={`white`}
      // borderRadius="15px"
      _hover={{
        //bg: "#49C755",
        filter: "brightness(1.1)",
      }}
      //href={`https://access.line.me/oauth2/v2.1/authorize?response_type=code&state=${process.env.REACT_APP_WEB_NAME}&redirect_uri=${process.env.REACT_APP_API_URL}/tw/signin&client_id=${process.env.REACT_APP_LINE_CLIENT_ID}&scope=profile&nonce=`}
    >
      {/* <BsLine className="text-xl mr-1" />
      <Text my="0">{i18n_common("LINElogin")}</Text> */}
    </Button>
  );
};

export default LineLogin;
